/**
 * Internal dependencies
 */
import Dashboard from "../components/builder-dashboard/Dashboard";
import MakeComponentMainPage from "../components/make-components/MakeComponentMainPage";
export const routes = [
    { path: '/', element: Dashboard },
    // { path: 'make-components', element: MakeComponentMainPage },
];